module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.b8e42971.ttf";